import React, { useEffect, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import Table from "react-bootstrap/Table";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { getUser, getUserRole, } from "../../../services/userMasterUser";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { addMasterLeadStatus, getLeadType, getMasterLeadStatus } from "../../../services/leads";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

export default function LeadStatusList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [loadingMore, setLoadingMore] = useState(false);

  const [otherLeadTypeValue, setOtherLeadTypeValue] = useState("")
  const [statusValue, setStatusValue] = useState("")

  const [displayStatusAddModel, setDisplayStatusAddModel] = useState(false);

  const onClickStatusAddModel = (item) => {
    setDisplayStatusAddModel(true);
  };
  const onHideStatusAddModel = () => {
    setOtherLeadTypeValue("")
    setStatusValue("")
    setDisplayStatusAddModel(false);
  };

  
  const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
          id: { value: null, matchMode: FilterMatchMode.CONTAINS },
          userName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          userLoginId: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const [activeOnlyChecked, setActiveOnlyChecked] = useState(false);


  

  const userData = {
    leadTypeIn: [],
    roleIn: [],
    statusIn: [],
    activeOnly: ""
    };

  const [leadTypeList, setLeadTypeList] = useState([])
  const [leadTypeIn, setLeadTypeIn] = useState('')
    const [userRoleData, setUserRoleData] = useState([])
  const [userRoleId, setUserRoleId] = useState('')
  
  const fetchData = (data) => {
    setLoadingMore(true);

    getMasterLeadStatus(data)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          setProducts(newData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  useEffect(() => {
    fetchData(userData);

    

    getUserRole()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const filterRole = Res.filter((item) => item.roleName === "ROLE_TELECALLER" || item.roleName === "ROLE_OPERATION")
          const services = filterRole.map((item) => ({
            label: item.roleName,
            value: item.roleName,
          }));
          setUserRoleData(services);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

       getLeadType()
            .then((response) => {
              if (!response.data.error) {
                const leadStatus = response.data.map((item) => ({
                  label: item,
                  value: item,
                }));
                const OtherType = {
                  label: "Other",
                  value: "Other",
                }
                const dataList = [...leadStatus, OtherType]
                setLeadTypeList(dataList);
              }
            })
            .catch(() => errorMessage());

  }, []);

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      leadTypeIn: [],
      roleIn: [],
      statusIn: [],
      activeOnly: activeOnlyChecked ? "yes" : "no"
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    const _filters = { ...filters };
    _filters.global.value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);

    fetchData({
      leadTypeIn: [],
      roleIn: [],
      statusIn: [],
      activeOnly: activeOnlyChecked ? "yes" : "no"
    });
  };

  const handleUserRoleIdFilter = (userRoleId) => {

    setUserRoleId(userRoleId)

    setFirst(0);
    setProducts([]);

    fetchData({
      leadTypeIn: leadTypeIn == [""] ? [] : [leadTypeIn],
      roleIn: userRoleId == [""] ? [] : [userRoleId],
      statusIn: [],
      activeOnly: activeOnlyChecked ? "yes" : "no"
    });
  };

  const handleLeadTypeInFilter = (leadTypeIn) => {

    setLeadTypeIn(leadTypeIn)

    setFirst(0);
    setProducts([]);

    fetchData({
      leadTypeIn: leadTypeIn == [""] ? [] : [leadTypeIn],
      roleIn: userRoleId == [""] ? [] : [userRoleId],
      statusIn: [],
      activeOnly: activeOnlyChecked ? "yes" : "no"
    });
  };

  const handleActiveOnlyFilter = (activeOnlyChecked) => {

    setActiveOnlyChecked(activeOnlyChecked)

    setFirst(0);
    setProducts([]);

    fetchData({
      leadTypeIn: leadTypeIn == [""] ? [] : [leadTypeIn],
      roleIn: userRoleId == [""] ? [] : [userRoleId],
      statusIn: [],
      activeOnly: activeOnlyChecked ? "yes" : "no"
    });
  }; 

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const handleStatusAddModel = (event) => {
      event.preventDefault();
  
      let data = {
        leadType: leadTypeIn === "Other" ? otherLeadTypeValue : leadTypeIn,
        role: userRoleId,
                status: statusValue,
                active: true,
              };
              addMasterLeadStatus(data)
                .then((response) => {
                  if (!response.data.error) {
                    if (response.data.success === false) {
                      errorMessage(response.data.message);
                    } else {
                      successMessage(response.data.message);  
                    }
                    fetchData(userData);
                    onHideStatusAddModel()
                  } else {
                    // errorMessage(response.data.errors.errors[0].message);
                  }
                })
                .catch((err) => {
                  errorMessage();
                });
    };
  

  const renderDialogStatusAddModel = () => (
      <Dialog
        header="Add Status"
       visible={displayStatusAddModel}
      onHide={() => onHideStatusAddModel()}
        breakpoints={{ "960px": "75vw" }}
        style={{ width: "50vw" }}
      >
        <div>
        <form onSubmit={handleStatusAddModel}>
            <div className="row mb-3">
             {leadTypeIn === "Other" &&
                <div
                className="col-md-6"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                 <label htmlFor="otherLeadType" className="form-label">
                   Other Lead Type
                 </label>
                 <InputText
                   type="text"
                   value={otherLeadTypeValue}
                   onChange={(e) => {
                     setOtherLeadTypeValue(e.target.value,);
                   }}
                   placeholder="Other Lead Type"
                   style={{ width: '100%' }}
                 />
                </div>
              </div>}
             <div
               className="col-md-6"
               style={{ display: "flex", justifyContent: "space-between" }}
             >
               <div>
                 <label htmlFor="status" className="form-label">
                   Status
                 </label>
                 <InputText
                   type="text"
                   value={statusValue}
                   onChange={(e) => setStatusValue(e.target.value)}
                   placeholder="Status"
                   style={{ width: '100%' }}
                 />
               </div>
             </div>
            </div>
           { statusValue && (
              <div className="col-md-12 text-center">
                <button
                  type="submit"
                  className="move-btn move-btn-blue"
                >
                  Submit
                </button>
              </div>
            )}
          </form>
        </div>
      </Dialog>
    );

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Lead Status List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >

                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search..."
                        style={{ width: '100%' }}
                      />
                      </div>
                      <div className="col-md">
                      <Dropdown
                          options={userRoleData}
                          optionLabel="label"
                          value={userRoleId}
                          style={{width:'100%'}}
                          placeholder="User Role"
                          onChange={(e) => handleUserRoleIdFilter(e.value)}
                        />
                      </div>
                    <div className="col-md">
                      <Dropdown
                        options={leadTypeList}
                        optionLabel="label"
                        value={leadTypeIn}
                        style={{ width: '100%' }}
                        placeholder="Lead Type"
                        onChange={(e) => handleLeadTypeInFilter(e.value)}
                      />
                    </div>
                    <div className="col-md">
                      <div className="flex align-items-center">
                        <Checkbox onChange={e => handleActiveOnlyFilter(e.checked)} checked={activeOnlyChecked}></Checkbox>
                        <label htmlFor="active" className="ml-2">Active </label>
                      </div>
                    </div>
                    {leadTypeIn && userRoleId && <div className="col-md-2" >
                        <Button
                        onClick={() => onClickStatusAddModel(
                          "displayStatusAddModel"
                        )}
                          className="move-btn move-btn-blue center-text"
                        >
                          Add
                        </Button>
                      </div>}
                    </div>
                   

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 10,
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    <div className="col-md-2" style={{ alignSelf: "center" }}>
                      <Link
                        to="/user-master/lead-status/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          // marginTop: 10,
                        }}
                      >
                        {/*<i
                          onClick={() =>
                            downloadPDF(
                              filteredProducts || products,
                              "download"
                            )
                          }
                          className="pi pi-download"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                        {/*<i
                          onClick={() =>
                            downloadPDF(filteredProducts || products, "print")
                          }
                          className="pi pi-print"
                          style={{
                            fontSize: "20px",
                            color: "#ff0101",
                            cursor: "pointer",
                          }}
                        ></i>*/}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[50, 100, 200]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'userName', 'userLoginId',]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="leadType"
                        header="Lead Type"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.leadType}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="role"
                        header="Role"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.role}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.status)}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="category"
                        header="Category"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.category.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()))}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="active"
                        header="Active"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.active ? "ACTIVE" : "INACTIVE"}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/lead-status/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogStatusAddModel()}</div>
    </main>
  );
}
